import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getStartGuideContent } from "./content";
import { useProjectStartGuide } from "./status/useProjectStartGuide";
import "./StartGuide.sass";

const SUPPORTED = ["LEPR", "LAuthorize"];

function routeOf(to = "") {
  return String(to).split("?")[0];
}

function Destination({ project }) {
  const location = useLocation();
  const content = getStartGuideContent(project);
  const guide = useProjectStartGuide(project, content);
  const required = guide.steps.filter((step) => step.category === "required");
  const matches = guide.steps.filter((step) => {
    const route = routeOf(content.steps?.[step.id]?.to);
    if (!route || step.category === "learn") return false;
    return location.pathname === route || location.pathname.startsWith(`${route}/`);
  });
  const longest = matches.reduce(
    (length, step) => Math.max(length, routeOf(content.steps?.[step.id]?.to).length),
    0
  );
  const closest = matches.filter(
    (step) => routeOf(content.steps?.[step.id]?.to).length === longest
  );
  const match =
    closest.find((step) => !step.complete) || closest[0];

  if (!match) return null;

  if (guide.notice?.stepId === match.id) {
    return (
      <div className="StartGuideDestination is-saved">
        <b>{guide.notice.message}</b>
        <button type="button" onClick={guide.clearNotice}>
          Hide
        </button>
      </div>
    );
  }

  if (match.complete || match.category === "learn") return null;

  const position = required.findIndex((step) => step.id === match.id);
  const label =
    position >= 0 ? `Task ${position + 1} of ${required.length}` : "Setup task";

  return (
    <div className="StartGuideDestination">
      <span>{label}</span>
      <b>{match.name}</b>
      <p>This task is marked complete after you save on this page.</p>
    </div>
  );
}

export default function StartGuideDestination() {
  const project = useSelector((state) => state.user.openProjectName);
  if (!SUPPORTED.includes(project)) return null;
  return <Destination project={project} />;
}
